/// <amd-module name="VSSUI/IdentityPicker" />
export * from "./Components/IdentityPicker/IdentityPicker";
export { IIdentityPickerProps } from "./Components/IdentityPicker/IdentityPicker.Props";
export * from "./Components/IdentityPickerDropdown/CustomIdentityPickerDropdown";
export { ICustomIdentityPickerDropdownProps } from "./Components/IdentityPickerDropdown/CustomIdentityPickerDropdown.Props";
export * from "./Components/IdentityPickerDropdown/IdentityPickerDropdown";
export { IIdentityPickerDropdownProps } from "./Components/IdentityPickerDropdown/IdentityPickerDropdown.Props";
export * from "./Components/IdentityPickerDropdown/IdentityPickerDropdownFilterBarItem";
export {
    IIdentityPickerDropdownFilterBarItemProps,
    IIdentityPickerDropdownFilterBarItemState
} from "./Components/IdentityPickerDropdown/IdentityPickerDropdownFilterBarItem.Props";
export {
    IdentityType,
    IIdentity,
    IPeoplePickerProvider,
    IPersonaConnections,
    ISharedIdentityPickerProps
} from "./Components/IdentityPickerDropdown/SharedIdentityPicker.Props";
export * from "./Components/IdentityPickerDropdown/IdentityPickerUtils";
